import { render } from "./DynamicTable2.vue?vue&type=template&id=93f25c54&scoped=true"
import script from "./DynamicTable2.vue?vue&type=script&lang=js"
export * from "./DynamicTable2.vue?vue&type=script&lang=js"

import "./DynamicTable2.vue?vue&type=style&index=0&id=93f25c54&lang=scss&scoped=true"

import exportComponent from "../../../../../DIARC/pixonanimation.az/webadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93f25c54"]])

export default __exports__